import React from 'react'
import DateTimePicker from 'material-ui-datetimepicker'
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog'
import moment from 'moment'
import brandTheme from '../../../Assets/Styles/brandTheme'
import { useFormChildLogic } from '../index'

const { colors } = brandTheme()

export const DateTimePickerUnstyled = props => {
  const { id, name, label, minutesStep, input = {}, error } = props
  const { onChange } = input
  const { value, updateForm } = useFormChildLogic({
    name: name,
    initValue: input.value,
  })

  const containerErrorStyles = error ? { border: '1px solid red' } : {}

  return (
    <div className={props.className}>
      {label && (
        <label className="label" htmlFor={id}>
          {label}
        </label>
      )}
      <DateTimePicker
        id={id}
        name={name}
        format="DD/MM/YYYY hh:mm a"
        minutesStep={minutesStep}
        value={value}
        onChange={val => {
          const formatedValue = moment(val).format('YYYY-MM-DDTHH:mm:ss.sss')
          onChange && onChange(formatedValue)
          updateForm(formatedValue)
        }}
        clearIcon={null}
        DatePicker={DatePickerDialog}
        TimePicker={TimePickerDialog}
        textFieldStyle={{
          position: 'relative',
          width: '100%',
          borderRadius: '4px',
          height: '52px',
          background: '#F8F8F8',
          border: 'none',
          padding: '0 20px',
          color: colors.secondary,
          outline: 'none',
          ...containerErrorStyles,
          ...props.textFieldStyle,
        }}
        {...props}
      />
      {error ? <span className="errorLabel">Field is requred</span> : null}
    </div>
  )
}
